import type { ApiConfiguration } from '@izimi/api';

type LinkPath = Record<string, string> | undefined;

export const createConfigurationLinks = (
  configuration: ApiConfiguration | undefined,
  language: string,
  url: string,
) => {
  const baseUrl = `${url}/${language}`;

  const privacyPolicyPaths = configuration?.privacyPolicyPaths as LinkPath;
  const signingPolicyPaths = configuration?.signingPolicyPaths as LinkPath;
  const ssnFAQPaths = configuration?.ssnFAQPaths as LinkPath;
  const cookiePolicyPaths = configuration?.cookiePolicyPaths as LinkPath;
  const termsAndConditionsPaths = configuration?.termsAndConditionsPaths as LinkPath;
  const marketingMailOptPaths = configuration?.marketingMailOptPaths as LinkPath;

  const privacyUrl = `${baseUrl}${privacyPolicyPaths?.[language]}`;
  const cookieUrl = `${baseUrl}${cookiePolicyPaths?.[language]}`;
  const marketingMailUrl = `${baseUrl}${marketingMailOptPaths?.[language]}`;
  const termsAndConditionsUrl = `${baseUrl}${termsAndConditionsPaths?.[language]}`;
  // the signing policy has to go to izimi.be on all front-ends
  const signingPolicyUrl = `https://izimi.be/${language}${signingPolicyPaths?.[language]}`;
  const ssnFAQurl = `https://izimi.be/${language}${ssnFAQPaths?.[language]}`;

  return {
    baseUrl,
    privacyUrl,
    cookieUrl,
    marketingMailUrl,
    termsAndConditionsUrl,
    signingPolicyUrl,
    ssnFAQurl,
  };
};
